import api from '../api/axios';
import { VideoEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export interface PaginatedVideosResponse {
  items: VideoEntity[];
  total: number;
  page: number;
  size: number;
  hasMore: boolean;
}

export interface S3FolderVideosResponse {
  prefix: string;
  folders: { folder: string; videos: string[] }[];
}

export const getVideosByMember = async (memberId: string, page?: number, size?: number, search?: string) => {
  const params: Record<string, any> = {};
  if (page && page > 0) params.page = page;
  if (size && size > 0) params.size = size;
  if (search && search.trim()) params.search = search.trim();
  const res = await api.get(withBase(`/videos/by-member/${memberId}`), { params });
  return res.data as PaginatedVideosResponse;
};

export const getActiveRenderJobByMember = async (memberId: string) => {
  const res = await api.get(withBase(`/video-render-jobs/active-by-member/${memberId}`));
  return res.data as { exists: boolean; job?: any };
};

export const getS3VideosByFolderPrefix = async (folder: string) => {
  const res = await api.get(withBase('/videos/s3-videos'), { params: { folder } });
  return res.data as S3FolderVideosResponse;
};

export const deleteVideoByUrl = async (videoUrl: string) => {
  const res = await api.post(withBase('/videos/delete-by-url'), { videoUrl });
  return res.data as { deleted: boolean };
};

export interface S3VideoItem {
  key: string;
  url: string;
  lastModified: string;
  size: number;
}

export const getS3FinalVideos = async () => {
  const res = await api.get(withBase('/videos/s3-final-videos'));
  return res.data as S3VideoItem[];
};

export const getS3MergedVideos = async () => {
  const res = await api.get(withBase('/videos/s3-merged-videos'));
  return res.data as S3VideoItem[];
};

export const createVideo = async (payload: Partial<VideoEntity>) => {
  const res = await api.post(withBase('/videos'), payload);
  return res.data as VideoEntity;
};

export interface CreateAwsSavedVideoDto {
  title: string;
  languageCode: string;
  type: string;
  videoUrl: string;
  createdAt: string;
}

export const createAwsSavedVideo = async (payload: CreateAwsSavedVideoDto) => {
  const res = await api.post(withBase('/aws-saved-videos'), payload);
  return res.data;
};

export const getSavedVideoUrls = async () => {
  const res = await api.get(withBase('/aws-saved-videos/saved-urls'));
  return res.data as string[];
};

export const getAwsSavedVideos = async () => {
  const res = await api.get(withBase('/aws-saved-videos'));
  return res.data;
};

export const deleteAwsSavedVideo = async (id: string) => {
  const res = await api.delete(withBase(`/aws-saved-videos/${id}`));
  return res.data;
};

const videoService = {
  getVideosByMember,
  getActiveRenderJobByMember,
  getS3VideosByFolderPrefix,
  deleteVideoByUrl,
  getS3FinalVideos,
  getS3MergedVideos,
  createVideo,
  createAwsSavedVideo,
  getSavedVideoUrls,
  getAwsSavedVideos,
  deleteAwsSavedVideo,
};

export default videoService;
